<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="m1.333 14.667 3.334-9.334 6 6-9.334 3.334Zm2.2-2.2 4.7-1.667L5.2 7.767l-1.667 4.7Zm6.167-4.1-.7-.7 3.733-3.734a1.75 1.75 0 0 1 1.284-.533c.5 0 .927.178 1.283.533l.4.4-.7.7-.4-.4a.791.791 0 0 0-.583-.233.791.791 0 0 0-.584.233L9.7 8.367ZM7.033 5.7l-.7-.7.4-.4a.771.771 0 0 0 .234-.567.771.771 0 0 0-.234-.566L6.3 3.033l.7-.7.433.434c.356.355.534.777.534 1.266 0 .49-.178.911-.534 1.267l-.4.4Zm1.334 1.333-.7-.7 2.4-2.4a.792.792 0 0 0 .233-.583.792.792 0 0 0-.233-.583L9 1.7l.7-.7 1.067 1.067c.355.355.533.783.533 1.283 0 .5-.178.928-.533 1.283l-2.4 2.4ZM11.033 9.7l-.7-.7L11.4 7.933a1.75 1.75 0 0 1 1.283-.533c.5 0 .928.178 1.284.533L15.033 9l-.7.7-1.066-1.067a.792.792 0 0 0-.584-.233.792.792 0 0 0-.583.233L11.033 9.7Z"
        />
    </svg>
</template>

<script setup lang="ts">
type PartyIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<PartyIconProps>();
</script>
